import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { extendConfiguration } from './config';
import * as Sentry from '@sentry/browser';
import { PwaInstallService } from './app/features/login/pwa-install.service';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
} from '@angular/router';

PwaInstallService.deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();
  // Stash the event so it can be triggered later
  PwaInstallService.deferredPrompt = e;
});

extendConfiguration().then(() => {
  if (environment.production) {
    enableProdMode();
  }

  if (environment.sentry) {
    Sentry.init({
      dsn: environment.sentry || undefined,
      environment: environment.envName || undefined,
      release: environment.version,
      sendDefaultPii: true,
    });
  }

  // add environment class to body for conditional styling
  if (environment.envName) {
    document.body.classList.add(`env-${environment.envName}`);
  }

  import('./app/app.config').then((m) => {
    import('./app/app').then((a) => {
      bootstrapApplication(a.App, m.appConfig)
        .then((ref) => {
          const injector = ref.injector;
          const router = injector.get(Router);
          const sub = router.events.subscribe((ev) => {
            if (
              ev instanceof NavigationEnd ||
              ev instanceof NavigationError ||
              ev instanceof NavigationCancel
            ) {
              // Fade out and remove the loader overlay
              const el = document.getElementById('app-loader');
              if (el) {
                el.classList.add('app-loader--hidden');
                window.setTimeout(() => {
                  el.remove();
                }, 350);
              }
              sub.unsubscribe();
            }
          });
        })
        .catch((err) => console.error(err));
    });
  });
});
